import React from 'react'
import { View, TouchableOpacity, TextInput } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text, Icon, SearchBar } from '@components'
import { getConversationHeaderStyles } from './style'
import { getCommonStyles } from '@utils'
import { Contact, useScreen } from '@hooks'
import { useLanguage } from '@context'

interface ConversationHeaderProps {
  onBackPress: () => void
  searchValue?: string
  onSearchChange?: (text: string) => void
  groupName?: string
  onGroupNameChange?: (text: string) => void
  selectedContacts?: Contact[]
  onRemoveContact?: (contactId: string) => void
  showSearchInput?: boolean
}

export const ConversationHeader: React.FC<ConversationHeaderProps> = ({
  onBackPress,
  searchValue = '',
  onSearchChange,
  groupName = '',
  onGroupNameChange,
  selectedContacts = [],
  onRemoveContact,
  showSearchInput = true
}) => {
  const theme = useTheme()
  const { isMobile, isWeb } = useScreen()
  const { t } = useLanguage()
  const commonStyles = getCommonStyles(theme)
  const styles = getConversationHeaderStyles(theme)
  const isGroup = selectedContacts.length > 1

  return (
    <View style={[styles.headerContainer, isWeb && {paddingTop: theme.spacing.md}]}>
      {/* Première ligne : Bouton retour + Input + Icône droite */}
      <View style={styles.topRow}>
        {/* Bouton retour */}
        <TouchableOpacity onPress={onBackPress}>
          <Icon name="arrowBack" size={25} color={theme.colors.text} />
        </TouchableOpacity>

        {/* Input de recherche */}
        <View style={styles.inputContainer}>
          {isGroup && (
            <TextInput
              value={groupName}
              onChangeText={onGroupNameChange}
              placeholder={t('messaging.groupNamePlaceholder')}
              placeholderTextColor={theme.colors.greyBlue}
              maxLength={60}
            />
          )}
          {!isGroup && (
            <Text type="titleBold">
              {t('messaging.createNewMessage')}
            </Text>
          )}
        </View>

        {/* Keeps the title where it was when an icon stood here. */}
        <View style={styles.rightButton} />
      </View>
      {showSearchInput && (
        <View style={!isMobile && commonStyles.row}>
          <SearchBar
            onChangeText={onSearchChange}
            value={searchValue}
            placeholder={t('messaging.recipientPlaceholder')}
          />
        </View>
      )}

      {/* Deuxième ligne : Tags des contacts sélectionnés */}
      {selectedContacts.length > 0 && (
        <View style={styles.tagsContainer}>
          <View style={styles.tagsWrapper}>
            {selectedContacts.map((contact) => (
              <View key={contact.id} style={styles.selectedContactTag}>
                <Text type="body" style={styles.tagName} numberOfLines={1}>
                  {contact.fullName}
                </Text>
                <TouchableOpacity
                  onPress={() => onRemoveContact?.(contact.id ?? '')}
                  style={styles.removeButton}
                >
                  <Icon name="cross" size={12} color="#1976D2" />
                </TouchableOpacity>
              </View>
            ))}
          </View>
        </View>
      )}
    </View>
  )
} 